import Http from '../http'

export const index = (page, search, key, sort) => {
  var url = `/customers?page=${page}`
  if (search) url = url + `&search=${search}`
  if (key) url = url + `&order_by=${key}`
  if (sort) url = url + `&sort=${sort}`
  return Http.get(url, { headers: { Authorization: localStorage.token } })
}
export const show = (id) => Http.get(`/customers/${id}`, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/customers/${id}`, { data }, { headers: { Authorization: localStorage.token } })
